import {
  cacheExchange,
  ClientOptions,
  createClient,
  fetchExchange,
  mapExchange,
  ssrExchange,
} from 'urql';
import { createFetch } from '@rea-argonaut/fetch';
import { getEnv } from '../helpers/getEnv';
import { read } from '@rea-argonaut/exchange';
import { logger } from '@rea-argonaut/observability';
import { devtoolsExchange } from '@urql/devtools';

export const URQL_CACHE_KEY = 'URQL_CACHE';

export const createUrqlClientConfig = async (): Promise<ClientOptions> => {
  const isClient = process.env.WEBPACK_TARGET === 'web';
  const experienceApiUrl = isClient
    ? getEnv.PUBLIC_EXPERIENCE_API_URL()
    : getEnv.INTERNAL_EXPERIENCE_API_URL();
  const url = `${experienceApiUrl}/api/graphql`;

  return {
    url,
    fetch: createFetch({}),
    fetchOptions: {
      credentials: 'include',
    },
    exchanges: [
      devtoolsExchange,
      cacheExchange,
      mapExchange({
        onError(error, operation) {
          logger.error({
            error,
            description: `urql operation ${operation.key} has errored with: ${error.name}`,
            customAttributes: {
              errorName: error.name,
              errorMessage: error.message,
              operation: JSON.stringify(operation),
            },
          });
        },
      }),
      ssrExchange({
        isClient,
        initialState: (await read(URQL_CACHE_KEY)) || undefined,
      }),
      fetchExchange,
    ],
  };
};

export const createUrqlClient = async () => {
  const urqlClientConfig = await createUrqlClientConfig();

  return createClient(urqlClientConfig);
};
